<!-- Default hero option with no carousel -->
<div>
  <ng-container *ngTemplateOutlet="heroContent; context: {item: block}"></ng-container>
</div>

<ng-template #heroContent let-item="item">
  <div class="wp-banner d-flex align-items-center">
    <div class="wp-banner__container container py-0">
      <div class="row flex-column-reverse flex-md-row align-items-stretch text-center text-md-left">
        <div class="col-12 col-md-6 d-flex flex-column justify-content-center">
          <h1 class="wp-banner__heading" [innerText]="item.data.heading" [style.color]="item.data.headingColour ?? 'revert'"></h1>
          <div class="wp-banner__content" [innerHTML]="item.data.content" [style.color]="item.data.contentColour ?? 'revert'"></div>
        </div>
        <!-- Image Column (Ensures Image Always Sits at the Bottom) -->
        <div class="col-12 col-md-6 d-flex flex-column justify-content-between">
          <div class="wp-banner__image mt-auto">
            <img class="img-fluid" [src]="parseURL(item.data.image)" [alt]="item.data.heading">
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>




